var _desc, _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAgileSurveyImage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 111 124",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "survey-image") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "l",
    width: 81,
    height: 98,
    rx: 1
  }), /*#__PURE__*/React.createElement("filter", {
    id: "m",
    x: "-9.9%",
    y: "-7.1%",
    width: "119.8%",
    height: "116.3%"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 1,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowBlurOuter1",
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.338532561 0"
  })), /*#__PURE__*/React.createElement("ellipse", {
    id: "d",
    cx: 4.8486,
    cy: 4.815,
    rx: 4.8486,
    ry: 4.815
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "c",
    cx: 4.8486,
    cy: 4.815,
    rx: 4.8486,
    ry: 4.815
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "b",
    cx: 4.8486,
    cy: 4.815,
    rx: 4.8486,
    ry: 4.815
  }), /*#__PURE__*/React.createElement("rect", {
    id: "a",
    width: 81,
    height: 98,
    rx: 1
  }), /*#__PURE__*/React.createElement("filter", {
    id: "o",
    x: "-9.9%",
    y: "-7.1%",
    width: "119.8%",
    height: "116.3%"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 1,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowBlurOuter1",
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.338532561 0"
  })), /*#__PURE__*/React.createElement("ellipse", {
    id: "k",
    cx: 4.8486,
    cy: 4.815,
    rx: 4.8486,
    ry: 4.815
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "j",
    cx: 4.8486,
    cy: 4.815,
    rx: 4.8486,
    ry: 4.815
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "i",
    cx: 4.8486,
    cy: 4.815,
    rx: 4.8486,
    ry: 4.815
  }), /*#__PURE__*/React.createElement("rect", {
    id: "h",
    width: 81,
    height: 98,
    rx: 1
  }), /*#__PURE__*/React.createElement("filter", {
    id: "n",
    x: "-9.9%",
    y: "-7.1%",
    width: "119.8%",
    height: "116.3%"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 1,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowBlurOuter1",
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.338532561 0"
  })), /*#__PURE__*/React.createElement("ellipse", {
    id: "g",
    cx: 4.8486,
    cy: 4.815,
    rx: 4.8486,
    ry: 4.815
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "f",
    cx: 4.8486,
    cy: 4.815,
    rx: 4.8486,
    ry: 4.815
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "e",
    cx: 4.8486,
    cy: 4.815,
    rx: 4.8486,
    ry: 4.815
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-199 -349)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(69 307)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(135 46)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    filter: "url(#m)",
    xlinkHref: "#l"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#l"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(6.8451 52.682)"
  }, /*#__PURE__*/React.createElement("mask", {
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#d"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#A0A4F8",
    xlinkHref: "#d"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(6.8451 66.844)"
  }, /*#__PURE__*/React.createElement("mask", {
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#A0A4F8",
    xlinkHref: "#c"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(6.8451 81.572)"
  }, /*#__PURE__*/React.createElement("mask", {
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#A0A4F8",
    xlinkHref: "#b"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 6.8451,
    y: 17.561,
    width: 39.93,
    height: 4.5318,
    fill: "#A0A4F8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6.8451,
    y: 28.324,
    width: 68.451,
    height: 4.5318,
    fill: "#A0A4F8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 21.966,
    y: 55.51,
    width: 18.824,
    height: 4.5318,
    fill: "#DDDEEE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 21.676,
    y: 69.217,
    width: 26.81,
    height: 4.5318,
    fill: "#DDDEEE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 21.676,
    y: 83.945,
    width: 38.218,
    height: 4.5318,
    fill: "#DDDEEE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 45.305,
    y: 55.51,
    width: 21.106,
    height: 4.5318,
    fill: "#DDDEEE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 54.19,
    y: 69.217,
    width: 17.683,
    height: 4.5318,
    fill: "#DDDEEE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6.8451,
    y: 6.7977,
    width: 46.204,
    height: 4.5318,
    fill: "#5658A9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 57.613,
    y: 6.7977,
    width: 17.113,
    height: 4.5318,
    fill: "#5658A9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6.8451,
    y: 39.653,
    width: 28.521,
    height: 4.5318,
    fill: "#A0A4F8"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(10 8)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    filter: "url(#o)",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(6.8451 52.682)"
  }, /*#__PURE__*/React.createElement("mask", {
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#k"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#A0A4F8",
    xlinkHref: "#k"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(6.8451 66.844)"
  }, /*#__PURE__*/React.createElement("mask", {
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#j"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#A0A4F8",
    xlinkHref: "#j"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(6.8451 81.572)"
  }, /*#__PURE__*/React.createElement("mask", {
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#i"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#A0A4F8",
    xlinkHref: "#i"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 6.8451,
    y: 17.561,
    width: 39.93,
    height: 4.5318,
    fill: "#A0A4F8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6.8451,
    y: 28.324,
    width: 68.451,
    height: 4.5318,
    fill: "#A0A4F8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 21.966,
    y: 55.51,
    width: 18.824,
    height: 4.5318,
    fill: "#DDDEEE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 21.676,
    y: 69.217,
    width: 26.81,
    height: 4.5318,
    fill: "#DDDEEE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 21.676,
    y: 83.945,
    width: 38.218,
    height: 4.5318,
    fill: "#DDDEEE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 45.305,
    y: 55.51,
    width: 21.106,
    height: 4.5318,
    fill: "#DDDEEE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 54.19,
    y: 69.217,
    width: 17.683,
    height: 4.5318,
    fill: "#DDDEEE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6.8451,
    y: 6.7977,
    width: 46.204,
    height: 4.5318,
    fill: "#5658A9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 57.613,
    y: 6.7977,
    width: 17.113,
    height: 4.5318,
    fill: "#5658A9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6.8451,
    y: 39.653,
    width: 28.521,
    height: 4.5318,
    fill: "#A0A4F8"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(20 16)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    filter: "url(#n)",
    xlinkHref: "#h"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#h"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(6.8451 52.682)"
  }, /*#__PURE__*/React.createElement("mask", {
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#g"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#A0A4F8",
    xlinkHref: "#g"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(6.8451 66.844)"
  }, /*#__PURE__*/React.createElement("mask", {
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#f"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#A0A4F8",
    xlinkHref: "#f"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(6.8451 81.572)"
  }, /*#__PURE__*/React.createElement("mask", {
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#e"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#A0A4F8",
    xlinkHref: "#e"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 6.8451,
    y: 17.561,
    width: 39.93,
    height: 4.5318,
    fill: "#A0A4F8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6.8451,
    y: 28.324,
    width: 68.451,
    height: 4.5318,
    fill: "#A0A4F8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 21.966,
    y: 55.51,
    width: 18.824,
    height: 4.5318,
    fill: "#DDDEEE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 21.676,
    y: 69.217,
    width: 26.81,
    height: 4.5318,
    fill: "#DDDEEE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 21.676,
    y: 83.945,
    width: 38.218,
    height: 4.5318,
    fill: "#DDDEEE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 45.305,
    y: 55.51,
    width: 21.106,
    height: 4.5318,
    fill: "#DDDEEE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 54.19,
    y: 69.217,
    width: 17.683,
    height: 4.5318,
    fill: "#DDDEEE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6.8451,
    y: 6.7977,
    width: 46.204,
    height: 4.5318,
    fill: "#5658A9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 57.613,
    y: 6.7977,
    width: 17.113,
    height: 4.5318,
    fill: "#5658A9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6.8451,
    y: 39.653,
    width: 28.521,
    height: 4.5318,
    fill: "#A0A4F8"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAgileSurveyImage);
export default __webpack_public_path__ + "static/media/agile-survey-image.8fb8607b.svg";
export { ForwardRef as ReactComponent };